export default __webpack_public_path__ + "static/media/Level26.9a478af7.svg";